import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';
import { OpcoUserType } from '@/bundle/_Opco/types/types';

export const getOpcoInternalUserApi = async (userId: string): Promise<ApiResponseType<OpcoUserType>> => {
  const uri = `/opco/internal/users/${userId}/`;

  return authApiService.GET(uri);
};
